export default "__VITE_ASSET__BmYy1LjK__"